import { useContext, useEffect, useState } from "react";
import CustomTable from "../../../components/customTable/customTable.component";
import "../../../routes/Admin/admin.styles.scss";
import { Options, SideBarContext } from "../../../context/sidebar.context";
import { useFetchDestinations } from "../../../api/queries/destinationQueries";
import moment from "moment";
import Button, {
  BUTTON_TYPE_CLASSES,
} from "../../../components/button/button.component";
import { FormTypes } from "../../../utils/formFactory";
import { FormContext } from "../../../context/form.context";
import FormModal from "../../../components/customForm/formModal.component";
import Layout from "../../../components/Layout";
import MaterialTable from "../../../components/customTable/MaterialTable";
import AdminGeneralTable from "../AdminGeneralTable";
import {
  useGetAdventuresQuery,
  useGetCountriesOptionsQuery,
  useGetDestinationOptionsQuery,
  useGetDestinationsQuery,
} from "../../../apiCaller/apis/getApi";
import AdminSectionTitle from "../AdminSectionTitle";
import { AdventureAdminTableColumns, DestinationAdminTableColumns } from "../../../utils/columns";
import {
  AdventureMapper,
  CountriesOptionMapper,
  DestinationMapper,
} from "../../../utils/DataMapper";
import { useDeleteAdventureMutation, useDeleteDestinationMutation } from "../../../apiCaller/apis/deleteApi";
import { toast } from "react-toastify";
import {
  AddAdventureSchema,
  AddAdventureUiSchema,
  AddDestinationSchema,
  AddDestinationUiSchema,
} from "../../../utils/forms";
import { GetTableListAPI } from "../../../apiCaller/getAPIsCaller";
import { useAddAdventureMutation, useAddDestinationMutation } from "../../../apiCaller/apis/postApi";
import { useUpdateAdventureMutation, useUpdateDestinationMutation } from "../../../apiCaller/apis/updateApi";

const AdminAdventures = () => {
  const {
    data: countries,
    error,
    isLoading,
    isFetching,
  } = GetTableListAPI({}, useGetCountriesOptionsQuery);
  const {
    data: destinationOptions,
    error: destinationOptionsError,
    isLoading: destinationOptionsIsLoading,
    isFetching: destinationOptionsIsFetching,
  } = GetTableListAPI({}, useGetDestinationOptionsQuery);
  const [
    deleteAdventure,
    {
      data: response,
      isLoading: deleteLoading,
      isError: postIsError,
      error: postError,
      isSuccess,
    },
  ] = useDeleteAdventureMutation({});
  const [
    addAdventure,
    {
      data: adAdventureResponse,
      isLoading: adAdventureLoading,
      isError: adAdventureIsError,
      error: adAdventureError,
      isSuccess: addAdventureIsSuccess,
    },
  ] = useAddAdventureMutation({});

  const [
    updateAdventure,
    {
      data: updateAdventureResponse,
      isLoading: updateAdventureLoading,
      isError: updateAdventureIsError,
      error: updateAdventureError,
      isSuccess: updateAdventureIsSuccess,
    },
  ] = useUpdateAdventureMutation({});

  const [countriesLookup, setCountriesLookup] = useState([]);

  const handleDelete = async (id, close) => {
    const result = await deleteAdventure(id);
    if (result) {
      if (result.data.IsSuccess) {
        toast("Adventure deleted successful");
      } else {
        toast("Action was unsuccessful");
      }
      close();
    }
  };

  const handleAddAdventure = async (data, close) => {
    console.log(data)
    const result = await addAdventure(data);
    if (result) {
      console.log(result?.data?.IsSuccess);
      if (
        result?.data?.IsSuccess !== undefined &&
        result?.data?.IsSuccess !== false
      ) {
        toast("Adventure Added successful");
        close();
      } else {
        toast("An error occured");
      }
    }
  };

  const handleUpdate = async (data, close) => {
    const result = await updateAdventure({
      adventureId: data.id,
      data: data,
    });
    if (result) {
      if (
        result?.data?.IsSuccess !== undefined &&
        result?.data?.IsSuccess !== false
      ) {
        toast("Adventure Updated successful");
        close();
      } else {
        toast("An error occured");
      }
    }
  };

  useEffect(() => {
    if (CountriesOptionMapper !== undefined && countries !== undefined) {
      setCountriesLookup(CountriesOptionMapper(countries));
    }
  }, [countries]);
  return (
    <Layout>
      <div className="mx-10">
        <div className="admin__header">{/* <Navigation/> */}</div>
        <main>
          <div>
            <AdminSectionTitle
              title={"Adventures"}
              subTitle={"A list of Adventures"}
              schema={AddAdventureSchema}
              uischema={AddAdventureUiSchema(destinationOptions)}
              addButtonTitle={"Adventure"}
              addFormTitle={"Add Adventure"}
              addFormSubtitle={"Adding Adventure"}
              handleSubmit={handleAddAdventure}
            />
          </div>

          <div className="admin__content-table">
            <AdminGeneralTable
              caller={useGetAdventuresQuery}
              tableInfo={{
                actionButtons: ["view"],
                toRoute: "/schedules",
                actionBtns: ["add-schedules"],
                hasMore: false,
                noActions: true,
                columns: AdventureAdminTableColumns,
              }}
              deleteFunc={handleDelete}
              mapper={AdventureMapper}
              deleteLoading={deleteLoading}
              updateSchema={AddAdventureSchema}
              updateUiSchema={AddAdventureUiSchema(destinationOptions)}
              updateSubmitFunc={handleUpdate}
              route={"Adventure"}
              title={"Adventure"}
              subtitle={"Adventure"}
            />
          </div>
        </main>
        <FormModal />
      </div>
    </Layout>
  );
};

export default AdminAdventures;
